import { CubeMapTexture } from './CubeMapTexture';
import { Context } from '../context/Context';

export class PlaceHolderCubeMapTexture extends CubeMapTexture {
  constructor(ctx: Context) {
    super();

    this.init(ctx);
  }

  protected init(ctx: Context): void {
    const gl = ctx.gl;
    let texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_CUBE_MAP, texture);
    for (let side of this.getSideMapping(ctx)) {
      gl.texImage2D(
        side.glCubeMapSide,
        0,
        gl.LUMINANCE,
        2,
        2,
        0,
        gl.LUMINANCE,
        gl.UNSIGNED_BYTE,
        new Uint8Array([
          255, 255, 255, 255, 0.0, 0.0, 0.0, 255, 0.0, 0.0, 0.0, 255, 255, 255, 255, 255,
        ]),
      );
    }
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.NEAREST);

    gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);

    this.glTexture = texture;
  }
}
